// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonScrollTop_root__x_nw1"};